export default __webpack_public_path__ + "static/media/assetTradeIcon4.f44e8763.webp";